<template>
  <div v-custom-outside-click="handleOutsideClick" class="search-box">
    <input
      ref="placeInput"
      class="place-input"
      type="text"
      :placeholder="addressInputValue.placeholder"
      :style="getInputStyle"
      tabindex="0"
      @focus="onInputSelected($event)"
      @click="onInputSelected($event)"
      @input="addressEntered($event)"
    >
    <google-search-box
      v-if="showAutoSuggest"
      :entered-input="enteredInput"
      :is-result="searchObject.searchResult"
      @set-requested-query="setRequestedQuery"
      @add-suggestion-entry="addSuggestionEntry"
    />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import GoogleSearchBox from '../../googlemap/GoogleSearchBox.vue'
import searchLayoutHandler from '../../mixins/searchLayoutHandler'
import colors from '../../../scss/_colors.scss'
import { isEmpty, hasNonEmptyKey } from '../../../utils/generalUtils'
import { splitSemiColonString } from '../../../utils/propertyUtils'
import { customAddressTextGenerator } from '../../../services/autoSearchService'

export default {
  components: { GoogleSearchBox },

  mixins: [searchLayoutHandler],

  data: () => ({
    enteredInput: [],
    showAutoSuggest: false
  }),

  computed: {
    ...mapState('common', ['searchTextParams']),
    ...mapState('client', ['customText']),

    getInputStyle() {
      let borderRadius = '0px'
      let height = '60px'
      let color = colors.hwayzShadow
      let borderColor = 'transparent'

      if (this.searchObject.searchResult) {
        borderRadius = '3px'
        height = '40px'
      }

      if (this.isFilled) {
        color = colors.hwayzKellyGreen
        if (this.searchObject.searchResult) {
          borderColor = colors.hwayzKellyGreen
        }
      }

      const btnStyles = {
        'border-radius': borderRadius,
        height,
        color,
        'line-height': height
      }
      return !this.searchObject.searchResult
        ? {
          ...btnStyles,
          margin: '0 0 2rem 0',
          'border-left': `0.1rem solid ${colors.hwayzGray}`
        }
        : {
          ...btnStyles,
          margin: '0',
          padding: '0 8px',
          border: `0.2rem solid ${borderColor}`,
          'text-align': 'center',
          'font-weight': '400 !important',
          'font-size': '1.3rem'
        }
    },

    isFilled() {
      return (
        (!isEmpty(this.enteredInput) &&
          !isEmpty(this.addressInputValue.text)) ||
        this.customText
      )
    }
  },

  watch: {
    addressInputValue: {
      handler: function(newValue) {
        if (!newValue.text) {
          this.setInitialAddressText()
        }
      }
    }
  },

  mounted() {
    if (!this.addressInputValue.text) {
      this.setInitialAddressText()
    }
  },

  methods: {
    ...mapMutations('common', {
      setAddressInputValue: 'SET_ADDRESS_INPUT_VALUE',
      resetMultipleRequestedObject: 'RESET_MULTIPLE_REQUESTED_OBJECT'
    }),
    ...mapMutations('client', {
      setCustomText: 'SET_CUSTOM_TEXT'
    }),

    setInitialAddressText() {
      const inputText = customAddressTextGenerator(this.lastNewQuery.query)
      if (inputText) this.setCustomText(true)
      this.$refs.placeInput.value = inputText
      this.enteredInput = []
    },

    setRequestedQuery(value) {
      this.showAutoSuggest = false
      this.setNewRequestedQuery({
        ...this.lastNewQuery.query,
        ...value.obj
      })
      this.$refs.placeInput.value = value.desc
      if (value.search) this.searchProperties()
    },

    addressEntered(event) {
      const enteredValue = event.target.value
      this.setAddressInputValue({ text: enteredValue, suggestion: false })

      if (enteredValue) {
        this.enteredInput = splitSemiColonString(enteredValue)
      }

      if (!isEmpty(enteredValue)) {
        this.showAutoSuggest = true
      } else {
        this.showAutoSuggest = false
        this.setNewRequestedQuery({
          ...this.lastNewQuery.query,
          City: '',
          PostalCode: '',
          StreetNumber: '',
          StreetName: '',
          Keywords: ''
        })
        this.resetMultipleRequestedObject()
      }
    },

    enterPressed() {
      if (!isEmpty(this.enteredInput) && this.enteredInput.length > 1) {
        // This functionality will be discussed
      }
    },

    addSuggestionEntry(suggestion) {
      const suggestionValue = suggestion.placeDesc
      const inputRef = this.$refs.placeInput
      const semiColonLastIndex = inputRef.value.lastIndexOf(';')
      if (semiColonLastIndex > -1) {
        inputRef.value = inputRef.value.substr(0, semiColonLastIndex)
        inputRef.value = `${inputRef.value}; ${suggestionValue}; `
      } else {
        inputRef.value = ''
        inputRef.value = `${suggestionValue}; `
      }
      this.enteredInput = splitSemiColonString(inputRef.value)
      this.setAddressInputValue({ text: inputRef.value, suggestion: true })
    },

    onInputSelected(event, entireSelect = false) {
      if (this.customText) {
        this.setCustomText(false)
        this.$refs.placeInput.value = ''
      }
      if (hasNonEmptyKey(this.searchTextParams)) {
        if (!this.showAutoSuggest) this.showAutoSuggest = true
      } else {
        if (this.showAutoSuggest) this.showAutoSuggest = false
      }
    },

    handleOutsideClick() {
      this.showAutoSuggest = false
      if (isEmpty(this.enteredInput)) this.setInitialAddressText()
    }
  }
}
</script>

<style lang="sass" scoped>
.search-box
  position: relative

.place-input
  background: $hwayzWhite
  width: 100%
  margin: 0 0 2rem
  padding-left: 1rem
  padding-right: 1rem
  &::placeholder
    color: $hwayzShadow
    opacity: 1
  &:-ms-input-placeholder
    color: $hwayzShadow
  &::-ms-input-placeholder
    color: $hwayzShadow
</style>
